import React from "react";


const Index = () => {
    return (
        <div>欢迎登录{process.env.REACT_APP_NAME}</div>
    )
}

export default Index